import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { ServerUrls } from '~src/commonInfra/url/ServerUrls';

import { PackageDetailsSubspace } from './PackageDetailsSubspace';
import { PackagesSiteSection } from './PackagesSiteSection';

// Routes between the Packages list page and the per-package detail page.
// Site-level settings use SpacesSiteUrls; server-level single-site deployments
// reach this subspace via ServerUrls. Mirrors ConnectedApplicationSubspaceRouter.
export function PackagesSubspaceRouter(): React.ReactElement {
  const siteUrls = siteUrlsSelector(getAppStore().getState());
  const serverUrls = ServerUrls.getInstance();
  return (
    <Switch>
      {siteUrls && (
        <Route exact path={siteUrls.packageDetailsPath(':luid')} render={({ match }) => (
          <PackageDetailsSubspace {...match} />
        )} />
      )}
      {siteUrls && (
        <Route exact path={siteUrls.settingsPackagesPath()} render={() => <PackagesSiteSection />} />
      )}
      <Route exact path={serverUrls.settingsPackagesPath()} render={() => <PackagesSiteSection />} />
    </Switch>
  );
}
